import {combineReducers} from "redux";
import {initReducer} from "./entities";

export const rootReducers = combineReducers({
  init: initReducer,
});
